<div class="basin-pb-4 basin-width-100">
  <div class="basin-pb-4">
    <strong>Warning:</strong> Setting the status to <strong>Paid</strong> will give the paying user access to the study area. Make sure the payment has been confirmed before proceeding.
  </div>
  <form [formGroup]="form" class="form-container">
    <formly-form class="basin-width-50" [form]="form" [fields]="prjCodeFields" [model]="model">
    </formly-form>
    <formly-form class="basin-width-50" [form]="form" [fields]="invoiceIdFields" [model]="model">
    </formly-form>
  </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
  <button pButton (click)="cancel()" label="Cancel" class="p-button-text basin-mr-6"></button>
  <button pButton type="submit" [disabled]="!model.projectCode" (click)="accept(model)"
    class="p-button-text" label="Proceed"></button>
</div>
